import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// @mui
import { Card, CardHeader, Box } from '@mui/material';
// components
import { forEach } from 'lodash';
import axiosInstance from '../../../utils/axiosInstance';
import EnhancedTable from '../../../components/table/urlTable';

// ----------------------------------------------------------------------
const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Name',
  },
  {
    id: 'rtsp_url',
    numeric: false,
    disablePadding: false,
    label: 'RTSP URL',
  },
  {
    id: 'stream_type',
    numeric: false,
    disablePadding: false,
    label: 'Type',
  },
  {
    id: 'resolution',
    numeric: false,
    disablePadding: false,
    label: 'Resolution',
  },
];

AppRtspList.propTypes = {
  title: PropTypes.string,
  host: PropTypes.string,
  subheader: PropTypes.string,
  rowCount: PropTypes.number.isRequired,
};

export default function AppRtspList({ title, subheader, host, rowCount, ...other }) {
  const [rowData, setRowData] = useState([]);
  const parseStreamApiResponse = (Arr) => {
    const parsedData = [];
    forEach(Arr, (obj) => {
      forEach(obj, (streamArr) => {
        forEach(streamArr, (stream) => {
          const temp = {
            name: stream.name,
            rtsp_url: stream.url,
            stream_type: stream.isMain ? 'Main stream' : 'Sub stream',
            resolution: stream.metadata?.resolution || 'Not available',
          };
          parsedData.push(temp);
        });
      });
    });
    setRowData(parsedData);
  };
  useEffect(() => {
    setRowData([]);
    axiosInstance
      .get(`${window.location.protocol}//${host}/api/v1/sensor/streams`)
      .then((response) => {
        if (response.data) {
          parseStreamApiResponse(response.data);
        }
      })
      .catch((error) => {
        console.log('Failed to get device streams', error);
      });
  }, [host]);

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />
      <Box>
        <EnhancedTable headCells={headCells} rowData={rowData} rowCount={rowCount} />
      </Box>
    </Card>
  );
}
